import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { UpdateNotice } from "./components/UpdateNotice";
import { ReauthDialog } from "./components/ReauthDialog";
import { FinanceIdleGuard } from "./components/FinanceIdleGuard";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Clients from "./pages/Clients";
import Orders from "./pages/Orders";

const Dashboard = lazy(() => import("./pages/Dashboard"));
const Quotes = lazy(() => import("./pages/Quotes"));
const Finance = lazy(() => import("./pages/Finance"));
const Payables = lazy(() => import("./pages/Payables"));
const CashFlow = lazy(() => import("./pages/CashFlow"));
const Debtors = lazy(() => import("./pages/Debtors"));
const Profile = lazy(() => import("./pages/Profile"));
const ClientLookup = lazy(() => import("./pages/ClientLookup"));
const Commissions = lazy(() => import("./pages/Commissions"));
const Audit = lazy(() => import("./pages/Audit"));
const Devices = lazy(() => import("./pages/Devices"));
const Security = lazy(() => import("./pages/Security"));
const NfeSettings = lazy(() => import("./pages/NfeSettings"));
const NfeNotes = lazy(() => import("./pages/NfeNotes"));
const Products = lazy(() => import("./pages/Products"));
const ProfitReport = lazy(() => import("./pages/ProfitReport"));
const Boletos = lazy(() => import("./pages/Boletos"));
const SicrediSettings = lazy(() => import("./pages/SicrediSettings"));

const PageLoader = () => (
  <div className="min-h-[40vh] flex items-center justify-center" data-testid="page-loader">
    <div className="w-7 h-7 border-2 border-zinc-700 border-t-indigo-500 rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <AuthProvider>
          <BrowserRouter>
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<Layout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="clientes" element={<Clients />} />
                  <Route path="pedidos" element={<Orders />} />
                  <Route path="orcamentos" element={<Quotes />} />
                  <Route path="produtos" element={<Products />} />
                  <Route path="consulta" element={<ClientLookup />} />
                  <Route path="comissoes" element={<Commissions />} />
                  <Route path="lucro" element={<FinanceIdleGuard label="Lucro Real"><ProfitReport /></FinanceIdleGuard>} />
                  <Route path="financeiro" element={<Finance />} />
                  <Route path="contas-a-pagar" element={<FinanceIdleGuard label="Contas a Pagar (custos)"><Payables /></FinanceIdleGuard>} />
                  <Route path="fluxo-caixa" element={<FinanceIdleGuard label="Fluxo de Caixa"><CashFlow /></FinanceIdleGuard>} />
                  <Route path="devedores" element={<Debtors />} />
                  <Route path="auditoria" element={<Audit />} />
                  <Route path="dispositivos" element={<Devices />} />
                  <Route path="seguranca" element={<Security />} />
                  <Route path="nfe-config" element={<NfeSettings />} />
                  <Route path="notas" element={<NfeNotes />} />
                  <Route path="boletos" element={<Boletos />} />
                  <Route path="sicredi-config" element={<SicrediSettings />} />
                  <Route path="perfil" element={<Profile />} />
                </Route>
              </Routes>
            </Suspense>
          </BrowserRouter>
          <Toaster theme="dark" position="top-right" richColors />
          <UpdateNotice />
          <ReauthDialog />
        </AuthProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
